import { gql } from "@apollo/client"

export const ROUND_REPORT = gql`
  mutation RoundReport($RoundReportInput: RoundReportInput!) {
    RoundReport(input: $RoundReportInput) {
      status {
        success
        name
        detail
      }
    }
  }
`
